import React from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import EditBlocker from '../../SectionWrapper/EditBlocker';

export default function OpenEditBlocker({ lease, terminateActiveAction }: LeaseActionProps) {
  function onCancelEdit() {
    terminateActiveAction();
  }

  return <EditBlocker isWizardView lease={lease} onCancelEdit={onCancelEdit} />;
}
